var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"avp-contact-link",attrs:{"href":_vm.emailLink}},[_vm._v(_vm._s(_vm.$t('generic.support.email')))])
}
var staticRenderFns = []

export { render, staticRenderFns }